var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11582_22382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 20C32 23.1826 30.7357 26.2348 28.4853 28.4853C26.2348 30.7357 23.1826 32 20 32C16.8174 32 13.7652 30.7357 11.5147 28.4853C9.26428 26.2348 8 23.1826 8 20C8 16.8174 9.26428 13.7652 11.5147 11.5147C13.7652 9.26428 16.8174 8 20 8C23.1826 8 26.2348 9.26428 28.4853 11.5147C30.7357 13.7652 32 16.8174 32 20ZM16.244 17.0495H17.4815C17.6885 17.0495 17.8535 16.88 17.8805 16.6745C18.0155 15.6905 18.6905 14.9735 19.8935 14.9735C20.9225 14.9735 21.8645 15.488 21.8645 16.7255C21.8645 17.678 21.3035 18.116 20.417 18.782C19.4075 19.5155 18.608 20.372 18.665 21.7625L18.6695 22.088C18.6711 22.1864 18.7113 22.2803 18.7814 22.3493C18.8516 22.4183 18.9461 22.457 19.0445 22.457H20.261C20.3605 22.457 20.4558 22.4175 20.5262 22.3472C20.5965 22.2768 20.636 22.1815 20.636 22.082V21.9245C20.636 20.8475 21.0455 20.534 22.151 19.6955C23.0645 19.001 24.017 18.23 24.017 16.6115C24.017 14.345 22.103 13.25 20.0075 13.25C18.107 13.25 16.025 14.135 15.8825 16.679C15.8804 16.7274 15.8883 16.7758 15.9056 16.8211C15.923 16.8664 15.9494 16.9076 15.9832 16.9423C16.0171 16.977 16.0577 17.0044 16.1025 17.0229C16.1474 17.0413 16.1955 17.0504 16.244 17.0495ZM19.7315 26.714C20.6465 26.714 21.275 26.123 21.275 25.3235C21.275 24.4955 20.645 23.9135 19.7315 23.9135C18.8555 23.9135 18.218 24.4955 18.218 25.3235C18.218 26.123 18.8555 26.714 19.733 26.714H19.7315Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11582_22382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.dd9a074242a058b468db76ae194ce2e7.svg";
export { ForwardRef as ReactComponent };